var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbNrWorkOnTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-141.001 -1496) translate(141.001 1496)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.093 24.562h-1.772L50.26 22h1.783a.366.366 0 0 1 .318.183l1.05 1.83a.366.366 0 0 1-.318.549z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-30.723 -13.234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2 22l-1.065 2.562H1.363a.366.366 0 0 1-.318-.549l1.05-1.83A.366.366 0 0 1 2.414 22z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-.996 -13.234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 24.562h-8.73L18.78 22h7.309l.055.194z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-11.068 -13.234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.944 13.83h-1.076L46.11 12h1.2a.366.366 0 0 1 .318.183l.63 1.1a.366.366 0 0 1-.318.549z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-28.092 -7.245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.077 12l-.761 1.83H8.243a.366.366 0 0 1-.318-.549l.63-1.1A.366.366 0 0 1 8.873 12z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-5.358 -7.245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 13.83h-6.3l.505-1.83h5.285z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-13.179 -7.245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.493 13.719h-1.215a.742.742 0 0 1-.706-.575l-.459-1.777-.713-2.744L36.306.5a.414.414 0 0 1 .06-.342.358.358 0 0 1 .292-.158h.366a.367.367 0 0 1 .34.243l3.247 8.38 1.065 2.744.491 1.267a.832.832 0 0 1-.067.735.721.721 0 0 1-.608.35z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-21.868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.422.5l-2.1 8.125-.71 2.744-.459 1.777a.742.742 0 0 1-.706.575h-1.21a.72.72 0 0 1-.609-.349.832.832 0 0 1-.067-.736l.491-1.267 1.065-2.746 3.247-8.38A.367.367 0 0 1 12.7 0h.366a.358.358 0 0 1 .291.156.414.414 0 0 1 .06.342z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-5.123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.948 5.464h-.556L42.78 4h.747a.366.366 0 0 1 .318.183l.421.732a.366.366 0 0 1-.318.549z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-26.318 -2.536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.557 4l-.607 1.464h-.556a.366.366 0 0 1-.318-.549l.421-.732A.366.366 0 0 1 13.814 4z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-8.286 -2.536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.363 5.464H23.89L24.293 4h3.667z",
    transform: "translate(-141.001 -1496) translate(141.632 1501.14) translate(-14.758 -2.536)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNrWorkOnTrack);
export default __webpack_public_path__ + "static/media/rb-nr-work-on-track.93efd3dabee3582b26edd8b22a37789d.svg";
export { ForwardRef as ReactComponent };